
export const textContent = [
    {
        image: "./icons/security.png",
        text: "Sigurnost",
        subtext: "Sve naše usluge su pažljivo razvijene i testirane kako bi osigurale da neće narušiti integritet vašeg vozila ili ugroziti vašu sigurnost na cesti. Naši tehničari koriste najnoviju opremu kako bi osigurali da svaka promjena bude sigurna i pouzdana.",
    },
    {
        image: "./icons/power.png",
        text: "Snaga",
        subtext: "Optimizacija performansi vašeg vozila može poboljšati vaše iskustvo vožnje, povećati učinkovitost goriva i produžiti životni vijek motora.",
    },
    {
        image: "./icons/tools.png",
        text: "FLEX Alat",
        subtext: "MagicMotorsport je sinonim za pouzdanost i inovaciju u svijetu motosporta. PVTuning se ponosi što koristi njihov profesionalni i siguran FLEX alat kako bi osigurao najbolje moguće rezultate za vaše vozilo.",
    },
];